import { GenericValue } from 'hisng';

import { BudgetSource } from 'app/fs/res/finance/model/budget-source/budget-source';
import { RestrictedValidity } from '../restricted_validity';

export class ResearchContract implements RestrictedValidity {
    id?: number;
    externalReferenceNumber: string;
    budgetSource: BudgetSource;
    incomes: ResearchContractIncome[];
    contractName: string;
    funderName: string;
    validFrom: Date;
    validTo: Date;
    status: GenericValue;
    internalReferenceNumber: string;
    commentary: string;

    requestFunds: ResearchContractFund[];

    constructor( externalReferenceNumber?: string, budgetSource?: BudgetSource, incomes?: ResearchContractIncome[] ) {
        this.externalReferenceNumber = externalReferenceNumber;
        this.budgetSource = budgetSource;
        this.incomes = incomes;
    }
}

export class ResearchContractIncome {
    id?: number;
    budgetSourceName: string;
    researchFundType: GenericValue;
    year: number;
    incomeAmount: number | string;

    constructor( researchFundType?: GenericValue, year?: number, incomeAmount?: number | string ) {
        this.researchFundType = researchFundType;
        this.year = year;
        this.incomeAmount = incomeAmount;
    }
}

export class ResearchContractFund {
    budgetPosition: GenericValue;
    researchFundType: GenericValue;
    incomeAmount: number;
    budgetSourceName: string;

    constructor( budgetPosition?: GenericValue, researchFundType?: GenericValue, incomeAmount?: number ) {
        this.budgetPosition = budgetPosition;
        this.researchFundType = researchFundType;
        this.incomeAmount = incomeAmount;
    }
}

